import React, { Component } from 'react';
import { connect } from 'react-redux';
import {

    setPlayerRecomendationKey,
    showHidePlayerRecomendationPopUp,
    setPlayerRecomendationFirstTimeFalse,
    playerRecomendationToggleAction
} from './../../../actions/FormationActions';
import OutsideNotifier from '../../../OutsideNotifier';
import common from '../../../common';
import config from './../../../config';


class PlayerRecomendationWeb extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dropDownActive: false,
            showPlyRecPopUpFirstTime: false
        }
    }

    selectSugestion = (e, obj) => {
        e.stopPropagation();
        if (this.props.playerRecomendedSelectedKey == obj.Key) {

        } else {
            this.props.setPlayerRecomendationKey(obj);
            common.customTracking('Select Player Recomendation Filter - ' + (config.playerRecomendationTrans[obj.Key] ? config.playerRecomendationTrans[obj.Key] : obj.Key), common.getPageName());

        }
        this.props.playerRecomendationToggleAction(false);
    }

    toggleDrpDown(val) {

        if (this.props.IsFirstTimeRecomend) {
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUp(true);
            common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
        } else {
            if (val == false) {
                this.props.playerRecomendationToggleAction(false);
            } else {
                this.props.playerRecomendationToggleAction(true);
                common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
            }
        }

    }



    resetPlayerRecomendation(e) {
        e.stopPropagation();
        var obj = {
            Key: "playerRecomendationdDefault",
        }
        this.props.setPlayerRecomendationKey(obj);
    }

    render() {
        let trans = this.props.trans;
        const className = common.makeClasses({
            'si-selectBoxes': true,
            'si-custom': true,
            'si-active': this.state.dropDownActive,
        });

        const classForSelected = common.makeClasses({
            "si-dropdown-btn": true,
            "si-flexBox": true,
            "si-selected-option": this.props.playerRecomendedSelectedKey.toLowerCase() != "playerrecomendationddefault"
        })
        return <div className="si-transfer-filter si-more-filters">
            <div className="si-dropdown-wrap" onClick={ () => { this.toggleDrpDown() } }>
                <div className={ className }>
                    <div className={ classForSelected }>
                        <span className="si-suggest si-flexBox">{ trans[this.props.playerRecomendedSelectedKey] ? trans[this.props.playerRecomendedSelectedKey] : this.props.playerRecomendedSelectedKey }</span>
                        { this.props.IsFirstTimeRecomend ? <span className="si-suggest-new si-flexBox">{ trans.new ? trans.new : "New" }</span> : null }
                        { this.props.playerRecomendedSelectedKey.toLowerCase() == "playerrecomendationddefault" ? null : <span className="si-close" onClick={ (e) => { this.resetPlayerRecomendation(e) } }>
                            <i className="icon-ucl-close"></i>
                        </span> }
                        <i className="icon-ucl-position"></i>
                    </div>
                    { this.props.playerRecomendationToggle ? <OutsideNotifier
                        handler={ () => this.toggleDrpDown(false) }>
                        <ul style={ common.setDropDownHeight("#playerRecomendationDropDownMobFilter", 34, this.props.playerRecomendationKeys.length) } className="si-dropdown-options">

                            { this.props.playerRecomendationKeys.map((obj) => {
                                const className = common.makeClasses({
                                    'si-active': obj.Key == this.props.playerRecomendedSelectedKey
                                })
                                return <li className={ className } key={ obj.Key } onClick={ (e) => { this.selectSugestion(e, obj) } }>
                                    <span>{ trans[obj.Key] ? trans[obj.Key] : obj.Key }</span>
                                </li>
                            }) }
                        </ul>    </OutsideNotifier> : null }
                </div>
            </div>
        </div>




    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerRecomendationKeys: state.formationData.playerRecomendationKeys,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend,
        showPlayerRecomMobPopUpFlag: state.formationData.showPlayerRecomMobPopUpFlag,
        playerRecomendationToggle: state.formationData.playerRecomendationToggle
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPlayerRecomendationKey: (obj) => dispatch(setPlayerRecomendationKey(obj)),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        setPlayerRecomendationFirstTimeFalse: (bool) => dispatch(setPlayerRecomendationFirstTimeFalse(bool)),
        playerRecomendationToggleAction: (bool) => dispatch(playerRecomendationToggleAction(bool))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerRecomendationWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerRecomendationWeb.js